import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ComponentLoader } from 'components';
import { codelists } from 'constants/codelists';
import fetch from 'features/common/fetch';
import { fetchTaskFilters } from 'features/views/settings/actions';
import { getTaskFilters } from 'features/views/settings/selectors';
import { getCodelistByName, getCodelistPropById } from 'utils';

import ListItem from './ListItem';

export const List = () => {
	const dispatch = useDispatch();

	const taskFilters = useSelector(getTaskFilters);
	const taskTypesCodelist = useSelector(getCodelistByName(codelists.taskTypes));
	const taskSubtypesCodelist = useSelector(getCodelistByName(codelists.taskSubtypes));

	useEffect(() => {
		dispatch(fetchTaskFilters());
		// eslint-disable-next-line
	}, []);

	const handleOnReload = useCallback(() => {
		dispatch(fetchTaskFilters());
	}, [dispatch]);

	const sortTaskFilterIds = useCallback(
		(a, b) => {
			const aTaskTypeDescription = getCodelistPropById(a.taskTypeId, taskTypesCodelist);
			const bTaskTypeDescription = getCodelistPropById(b.taskTypeId, taskTypesCodelist);
			return aTaskTypeDescription.localeCompare(bTaskTypeDescription);
		},
		[taskTypesCodelist],
	);

	const hasFetchError = useSelector(fetch.selectors.getFetchState(fetch.constants.urls.userFilters))?.error;

	return (
		<ComponentLoader
			fetchStorePath={fetch.constants.urls.userFilters}
			onReload={handleOnReload}
			error={hasFetchError}
		>
			{taskFilters &&
				taskFilters
					.sort(sortTaskFilterIds)
					.map((task) => (
						<ListItem
							key={task.id}
							filterId={task.id}
							taskTypesCodelist={taskTypesCodelist}
							taskSubtypesCodelist={taskSubtypesCodelist}
						/>
					))}
		</ComponentLoader>
	);
};

export default List;
